<template>
    <div class="hos-form">
        <div class="sub_title cb"><img src="../../assets/icon/Rectangle2.png" class="mr10 imgb">预约规则</div>
        <div class="mt20 bt br bb bl pl20 pr20 pt20 pb20 fs14">
            <p class="mb20">预约周期：14天</p>
            <p class="mb20">放号时间：8:30</p>
            <p class="mb20">停挂时间：14:00:00</p>
            <p class="mb80">退号时间：就诊前一工作日24:00前取消</p>
        </div>
    </div>
</template>

<script>
  import {CONSULTATION_STATUS} from "../../lib/config";

  export default {
    name: "orderRule",
    props: {
      value: {
        type: String,
        default: '1'
      },
    },
    data() {
      return {
        id: '1',
        list: CONSULTATION_STATUS,
        areaList:['杭州 |','宁波 |','温州 |','嘉兴 |','湖州'],
        levelList:['三级医院 |','二级医院 |','一级医院'],
      }
    },
    watch: {
      id(newV) {
        this.$emit('input', newV);
      }
    }
  }
</script>

<style scoped lang="scss">
    .hos-form{
        padding: 10px 20px;
        color: #666666;
        span+span{
            margin-right: 10px;
            cursor: pointer;
        }
    }
    .sub_title{
        padding: 5px 0px;
        color: #1E1E1E;
    }

    .cb{
        font-weight: bold;
        color: #333333;
    }
    .imgb{
        vertical-align: bottom;
    }
</style>
